import MediaBuying from './MediaBuying.page';

export default MediaBuying;
